export default {
      id: "logo_tictactoe_color-usage",
      viewBox: "0 0 184 30",
      url: __webpack_public_path__ + "sprite.svg#logo_tictactoe_color",
      toString: function () {
        return this.url;
      }
    }